import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-coming-soon',
    templateUrl: './coming-soon.component.html',
    styleUrls: ['./coming-soon.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ComingSoonComponent {}
